var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorPortfolio01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 1500",
    style: {
      enableBackground: "new 0 0 1500 1500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C25443;}\n\t.st1{fill:#AE4B3C;}\n\t.st2{opacity:0.25;fill:#FFFFFF;}\n\t.st3{fill:none;}\n\t.st4{fill:#D0D2D3;}\n\t.st5{fill:#BBBDBD;}\n\t.st6{fill:#E6E7E8;}\n\t.st7{fill:#2D2D2E;}\n\t.st8{fill:#C3996B;}\n\t.st9{fill:#AF8960;}\n\t.st10{fill:#603813;}\n\t.st11{fill:#A87C4F;}\n\t.st12{fill:none;stroke:#8A5D3B;stroke-width:3;stroke-miterlimit:10;}\n\t.st13{opacity:0.2;fill:#231F20;}\n\t.st14{fill:#BBBDBF;}\n\t.st15{fill:#DDDEDF;}\n\t.st16{fill:#906548;}\n\t.st17{fill:#B58E64;}\n\t.st18{fill:#896642;}\n\t.st19{fill:#A87C4F;stroke:#6A4D32;stroke-width:3;stroke-miterlimit:10;}\n\t.st20{fill:#D0D2D3;stroke:#9FA1A3;stroke-width:3;stroke-miterlimit:10;}\n\t.st21{fill:#A5F1E9;}\n\t.st22{fill:#8CB347;}\n\t.st23{fill:#603E2A;}\n\t.st24{fill:none;stroke:#231F20;stroke-width:4;stroke-miterlimit:10;}\n\t.st25{fill:#231F20;}\n\t.st26{fill:#8A5D3B;}\n\t.st27{opacity:0.2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1337.84,923.99c0,13.26-1.3,26.21-3.82,38.71H165.23c-2.03-12.6-3.07-25.54-3.07-38.71 c0-134.93,109.39-244.3,244.31-244.3c28.63,0,56.1,4.93,81.63,13.98C537.78,590.19,643.54,518.75,766,518.75 c141.34,0,260.47,95.19,296.74,224.97c24.04-10.49,50.61-16.31,78.52-16.31C1249.83,727.41,1337.84,815.42,1337.84,923.99z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorPortfolio01);
export default __webpack_public_path__ + "static/media/vector-portfolio-01.a4e0b17cec78b42b7429357eba38846f.svg";
export { ForwardRef as ReactComponent };